module.exports = __webpack_public_path__ + "img/header-img.18e212a3.png";